import { State } from '../../reducers/rootReducer'
import Model from '../../../entities/Model'

const allModelsDataSelector = (state: State): Model[] => state.allModelsData.models

export default allModelsDataSelector
